
// this function is used to filter the data based on the filter key and filter text
// export const filterFromData = (tableData, filterKey, filterText)=>{
//   if(filterKey === "all"){
//     return tableData
//   }

//     return tableData && tableData?.filter(
//         item => item[filterKey] && item[filterKey].toLowerCase().includes(filterText.toLowerCase()),
//       );
// }

export const filterFromData = (tableData, filterText) => {
  if (!filterText) {
    return tableData;
  }

  return tableData && tableData.filter(item => {
    return Object.values(item).some(value =>
      value && value.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });
};
